export default __webpack_public_path__ + "static/media/close.6ece318e.svg";